import Vue from 'vue';

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)


// WEBPACK FOOTER //
// ./src/plugins/mask.js